import type { PostDeleteFiatBankAccountResult } from './apiSchema';
import type { DeleteFiatBankAccountResponse } from './schema';

export function normalizePostDeleteFiatBankAccount(
  data: PostDeleteFiatBankAccountResult,
): DeleteFiatBankAccountResponse {
  return { responseCode: +data.code };
}
